import AUTH_TYPES from "../types/authTypes";

export const resetState = () => ({
  type: AUTH_TYPES.RESET_STATE,
});

export const resetForms = () => ({
  type: AUTH_TYPES.RESET_FORMS,
});

export const loginBegin = () => ({
  type: AUTH_TYPES.LOGIN_BEGIN,
});

export const loginSuccess = (data) => ({
  type: AUTH_TYPES.LOGIN_SUCCESS,
  payload: data,
});

export const logoutFailure = (error) => ({
  type: AUTH_TYPES.LOGOUT_FAILURE,
  payload: error,
});

export const logoutBegin = () => ({
  type: AUTH_TYPES.LOGOUT_BEGIN,
});

export const logoutSuccess = (data) => ({
  type: AUTH_TYPES.LOGOUT_SUCCESS,
  payload: data,
});

export const loginFailure = (error) => ({
  type: AUTH_TYPES.LOGIN_FAILURE,
  payload: error,
});

export const signupBegin = (data) => ({
  type: AUTH_TYPES.SIGNUP_BEGIN,
  payload: data,
});

export const signupSuccess = (data) => ({
  type: AUTH_TYPES.SIGNUP_SUCCESS,
  payload: data,
});

export const signupFailure = (error) => ({
  type: AUTH_TYPES.SIGNUP_FAILURE,
  payload: error,
});

export const setPasscode = (passcode, schoolSelectionEnabled) => ({
  type: AUTH_TYPES.SET_PASSCODE,
  payload: { passcode, schoolSelectionEnabled },
});

export const sendResetLinkBegin = () => ({
  type: AUTH_TYPES.SEND_RESET_LINK_BEGIN,
});

export const sendResetLinkSuccess = () => ({
  type: AUTH_TYPES.SEND_RESET_LINK_SUCCESS,
});

export const sendResetLinkFailure = (error) => ({
  type: AUTH_TYPES.SEND_RESET_LINK_FAILURE,
  payload: error,
});

export const resetPasswordBegin = () => ({
  type: AUTH_TYPES.RESET_PASSWORD_BEGIN,
});

export const resetPasswordSuccess = () => ({
  type: AUTH_TYPES.RESET_PASSWORD_SUCCESS,
});

export const resetPasswordFailure = (error) => ({
  type: AUTH_TYPES.RESET_PASSWORD_FAILURE,
  payload: error,
});

export const submitPasscodeBegin = () => ({
  type: AUTH_TYPES.SUBMIT_PASSCODE_BEGIN,
});

export const submitPasscodeSuccess = (data) => ({
  type: AUTH_TYPES.SUBMIT_PASSCODE_SUCCESS,
  payload: data,
});

export const submitPasscodeFailure = (error) => ({
  type: AUTH_TYPES.SUBMIT_PASSCODE_FAILURE,
  payload: error,
});

export const fetchSchoolsBegin = () => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_BEGIN,
});

export const fetchSchoolsSuccess = (data) => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_SUCCESS,
  payload: data,
});

export const fetchSchoolsFailure = (error) => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_FAILURE,
  payload: error,
});

export const fetchSchoolsByPasscodeBegin = () => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_BEGIN,
});

export const fetchSchoolsByPasscodeSuccess = (data) => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_SUCCESS,
  payload: data,
});

export const fetchSchoolsByPasscodeFailure = (error) => ({
  type: AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_FAILURE,
  payload: error,
});

export const fetchRolesBegin = () => ({
  type: AUTH_TYPES.FETCH_ROLES_BEGIN,
});

export const fetchRolesSuccess = (data) => ({
  type: AUTH_TYPES.FETCH_ROLES_SUCCESS,
  payload: data,
});

export const fetchRolesFailure = (error) => ({
  type: AUTH_TYPES.FETCH_ROLES_FAILURE,
  payload: error,
});

export const fetchGradesBegin = () => ({
  type: AUTH_TYPES.FETCH_GRADES_BEGIN,
});

export const fetchGradesSuccess = (data) => ({
  type: AUTH_TYPES.FETCH_GRADES_SUCCESS,
  payload: data,
});

export const fetchGradesFailure = (error) => ({
  type: AUTH_TYPES.FETCH_GRADES_FAILURE,
  payload: error,
});

export const createGroupBegin = () => ({
  type: AUTH_TYPES.CREATE_GROUP_BEGIN,
});

export const createGroupSuccess = (data) => ({
  type: AUTH_TYPES.CREATE_GROUP_SUCCESS,
  payload: data,
});

export const createGroupFailure = (error) => ({
  type: AUTH_TYPES.CREATE_GROUP_FAILURE,
  payload: error,
});

export const fetchProfileBegin = () => ({
  type: AUTH_TYPES.FETCH_PROFILE_BEGIN,
});

export const fetchProfileSuccess = (data) => ({
  type: AUTH_TYPES.FETCH_PROFILE_SUCCESS,
  payload: data,
});

export const fetchProfileFailure = (error) => ({
  type: AUTH_TYPES.FETCH_PROFILE_FAILURE,
  payload: error,
});

export const updateProfileBegin = () => ({
  type: AUTH_TYPES.UPDATE_PROFILE_BEGIN,
});

export const updateProfileSuccess = (data) => ({
  type: AUTH_TYPES.UPDATE_PROFILE_SUCCESS,
  payload: data,
});

export const updateProfileFailure = (error) => ({
  type: AUTH_TYPES.UPDATE_PROFILE_FAILURE,
  payload: error,
});
